<template>
  <span v-if="hasComplaintsReceipt">
    <DocumentAnalysisBadge
      :verdict="analysisVerdict"
      :is-analyzed="Boolean(complaintsReceiptAnalyzedAt)"
      :has-error="analysisHasError"
      :tooltip="analysisBadgeLabel"
      :clickable="canOpenAnalysisModal"
      @click="analysisModalOpen = true"
    />
    <ComplaintsReceiptAnalysisModal
      :open="analysisModalOpen"
      :analysis="complaintsReceiptAnalysis"
      :analyzed-at="complaintsReceiptAnalyzedAt"
      :analysable-id="declaration.id"
      analysable-type="Claims::Declaration"
      :claim-active="claimActive"
      @close="analysisModalOpen = false"
      @retry-success="$emit('retry-success')"
    />
  </span>
</template>

<script>
import { useI18n } from "vue-i18n";
import DocumentAnalysisBadge from "@/components/claim/details/DocumentAnalysisBadge.vue";
import ComplaintsReceiptAnalysisModal from "@/components/claim/details/ComplaintsReceiptAnalysisModal.vue";
import { verdictLabel } from "@/components/claim/details/complaintsReceiptAnalysisFormatter";

export default {
  components: {
    DocumentAnalysisBadge,
    ComplaintsReceiptAnalysisModal,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  emits: ["retry-success"],
  props: {
    declaration: {
      type: Object,
      default: null,
    },
    claimActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      analysisModalOpen: false,
    };
  },

  computed: {
    hasComplaintsReceipt() {
      return (this.declaration?.complaintsReceipt?.length || 0) > 0;
    },
    complaintsReceiptAnalysis() {
      return this.declaration?.complaintsReceiptAnalysis || null;
    },
    complaintsReceiptAnalyzedAt() {
      return this.declaration?.complaintsReceiptAnalyzedAt || null;
    },
    analysisVerdict() {
      return this.declaration?.complaintsReceiptAnalysisVerdict || null;
    },
    analysisHasError() {
      return Boolean(this.complaintsReceiptAnalysis?.error);
    },
    canOpenAnalysisModal() {
      return Boolean(this.complaintsReceiptAnalyzedAt) || this.analysisHasError;
    },
    analysisBadgeLabel() {
      if (this.analysisHasError) return this.t("unavailable");
      if (!this.complaintsReceiptAnalyzedAt) return this.t("not_analyzed");
      return verdictLabel(this.analysisVerdict);
    },
  },
};
</script>

<i18n src="./ComplaintsReceiptAnalysisBadge.i18n.json"></i18n>
